import { nextTick, ref, watch } from "vue";
import { defineStore } from "pinia";
import { useRouter } from '@library/Services';

export const getBackButton = defineStore( 'back-button', () =>
{
    const isVisible = ref( false );
    const showBackground = ref( false );
    const router = useRouter();

    watch( () => router.current.value.path, p =>
    {
        isVisible.value = false;
        showBackground.value = false;
    } );

    return { isVisible, showBackground };

} );

/**
 * Adds an anchored and floating back button to the page
 * @param isVisible 
 * @param showBackground 
 */
export function useBackButton( isVisible?: boolean, showBackground?: boolean )
{
    nextTick( () =>
    {
        const backButton = getBackButton();
        backButton.isVisible = isVisible === true || isVisible == undefined;
        backButton.showBackground = showBackground === true || showBackground == undefined;
    } );
}